import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { SessionSummary } from '@/lib/types';

export function useSessionSummary(
  sessionId: string,
): ReturnType<typeof useQuery<SessionSummary>> {
  return useQuery({
    queryKey: ['practice-session-summary', sessionId],
    queryFn: () => api.fetch<SessionSummary>(`/practice-sessions/${sessionId}/summary`),
    enabled: Boolean(sessionId),
  });
}
